import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';

import {IonicModule} from '@ionic/angular';

import {StudentProgressPageRoutingModule} from './student-progress-routing.module';

import {StudentProgressPage} from './student-progress.page';
import {ComponentsModule} from "../../shared/components/components.module";
import {SharedModule} from "../../shared/shared.module";
import {TranslocoDirective} from "@jsverse/transloco";
import {RoundProgressComponent} from "angular-svg-round-progressbar";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        StudentProgressPageRoutingModule,
        ComponentsModule,
        SharedModule,
        TranslocoDirective,
        RoundProgressComponent
    ],
    declarations: [StudentProgressPage],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class StudentProgressPageModule {
}
